import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import Pagination from "react-js-pagination";
import DanhSachKiemKhoApi from "../../../../service/danhSachKiemKhoApi";

export const ChiTietDanhSachKiemKho = (props) => {
  const dataInit = {
    List: [],
    TotalQuantity: 0,
  };
  const [dataChiTiet, UpdateDataChiTiet] = useState(dataInit);
  const ChiTiet = () => {
    DanhSachKiemKhoApi.chiTietBienBanKiemKho(props.bienbanId).then(
      (response) => {
        UpdateDataChiTiet({
          ...dataChiTiet,
          List: response.data.List,
          TotalQuantity: response.data.TotalQuantity,
        });
      }
    );
  };
  // console.log(dataChiTietThuChi);
  useEffect(() => {
    ChiTiet();
    return () => {
      UpdateDataChiTiet({}); // This worked for me ** fix: To fix, cancel all subscriptions and asynchronous tasks in a use Effect cleanup function
    };
  }, []);

  const listItem = () => {
    return (
      dataChiTiet.List != null &&
      dataChiTiet.List.map((item, index) => {
        return (
          <>
            <tr>
              <td>{item.STT}</td>
              <td>{item.MaTaiSan}</td>
              <td className="text-left">{item.TenTaiSan}</td>
              <td>{item.MaHopDong}</td>
              <td className="text-center">{item.StoreName}</td>
              <td className="text-center">
                {item.Status === false && <span>Chưa kiểm</span>}
                {item.Status === true && <span>Đã kiểm</span>}
              </td>
            </tr>
          </>
        );
      })
    );
  };
  return (
    <Modal
      {...props}
      size="modal-new-size modal-new-size"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left popup-detail"
    >
      <Modal.Header>
        <h4 className="modal-title  color7-bold" id="myModalLabel16">
          <span className="btn-icon-right">
            <img  src="/app-assets/images/logo-quan-ly-tai-san.png" />
          </span>{" "}
          Kiểm kho
        </h4>
        <button
          type="button"
          className="close-popup-new"
       onClick={props.onHide}
        >
          <img src="/app-assets/images/icon-dong-popup-v2.png" />
        </button>
      </Modal.Header>
      <Modal.Body>
        <form className="form tat-toan">
          <div className="form-body">
            <div className="card collapse-icon accordion-icon-rotate">
              <div
                id="headingCollapse53"
                className="card-header border-info"
                href="#collapse53"
                aria-expanded="true"
                aria-controls="collapse53"
              >
                <a
                  className="card-title lead info collapsed"
                  href={() => false}
                >
                  <h3>Kiểm kho</h3>
                </a>
              </div>
              <div
                id="collapse53"
                aria-labelledby="headingCollapse53"
                className="card-collapse collapse show"
                aria-expanded="true"
              >
                <div className="card-content">
                  <div className="card-body">
                    <div className="table-responsive table-2">
                      <table className="table table-bordered mb-0">
                        <thead>
                          <tr>
                            <th className="color7-bold">STT</th>
                            <th className="color7-bold">Mã tài sản</th>
                            <th className="text-left color7-bold">Tên tài sản</th>
                            <th className="color7-bold">Mã hợp đồng</th>
                            <th className="text-center color7-bold">Kho</th>
                            <th className="text-center color7-bold">Trạng thái</th>
                          </tr>
                        </thead>
                        <tbody>{listItem()}</tbody>
                      </table>
                    </div>
                    {/* <div
                        className={
                          "paniation-new paniation-new1 d-flex justify-content-center mt-1" +
                          (TotalQuantity === 0 ? "hidden" : "")
                        }
                      >
                        <nav aria-label="Page navigation">
                          <Pagination
                            activePage={dataSearch.pageIndex}
                            itemsCountPerPage={dataSearch.pageSize}
                            totalItemsCount={TotalQuantity}
                            pageRangeDisplayed={5}
                            onChange={this.handlePageChange}
                            itemClass="page-item"
                            linkClass="page-link"
                            activeClass="active"
                          />
                        </nav>
                      </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer className="modal-footer button-popup-new-size">
          <button
                  type="button"
                  class="btn btn-new-main btn-closenew"
                  href={() => false}
                  onClick={props.onHide}
                >
                  <span>
                    <i class="mdi mdi-close"></i>
                  </span>
                  &nbsp; Đóng &nbsp;
                </button>
      </Modal.Footer>
    </Modal>
  );
};
